<template>
  <div>
    <div v-if="rows.length" id="dtItemList">
      <!-- PageSize input and search -->
      <div v-if="hasPaginate" class="mb-1">
        <div  class="pl-1">
          {{$t('dataTable.labels.show[0]')}}<b>{{totalRecord}}</b>{{$t('dataTable.labels.show[1]')}}<b>{{fromRecord}}</b>{{$t('common.labels.fromTo')}}<b>{{toRecord}}</b>
        </div>
        <div class="pl-1 pr-1">
          <table cellspacing="0" cellpadding="0" style="border:none;">
            <tbody>
              <tr height="28px">
                <td align="left" style="border:none;">
                  <select v-model="pageSize" @change="updatePageSize">
                    <option v-for="(option, index) in options" :key=index :value="option.value">{{option.text}}</option>
                  </select>
                </td>
                <td style="border:none;">
                  <a @click="firstPage()" style="cursor: pointer;">
                    <img :src="require('../assets/img/btnBarleft_b.gif')">
                  </a>
                  <a @click="previousPage()" style="cursor: pointer;">
                    <img :src="require('../assets/img/btnLeft_b.gif')">
                  </a>
                </td>
                <td class="d-flex" style="border:none;">
                    <select v-model="pageNo" @change="changePage">
                      <option v-for="(page, index) in Math.ceil(totalRecord/pageSize)" :key=index :value="page">{{page}}</option>
                    </select>
                    <span style="margin-top: 0.1rem;"><font style="font-size:14px;">/{{Math.ceil(totalRecord/pageSize)}}</font></span>
                </td>
                <td align="right" style="border:none;">
                  <a @click="nextPage()" style="cursor: pointer;">
                    <img :src="require('../assets/img/btnRight_b.gif')">
                  </a>
                  <a @click="lastPage()" style="cursor: pointer;">
                    <img :src="require('../assets/img/btnBarright_b.gif')">
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- PageSize input and search -->
      <slot name="Header" v-show="!isDisplay"></slot>
      <!-- Main table type 1,2,3-->
      <div v-if="typeTable == 2 || typeTable == 3" class="border text-center lead font-weight-bold mt-1">{{headerLabel}}</div>
      <div class="wrap-table mt-1">
        <!-- fix-header -->
        <div v-if="typeTable != 2 && typeTable != 3" id="tableHeader" ref="tableHeader" class="table-responsive header-style" :style="(isWidthAuto ? 'width:auto;' : styleWidth)+'max-height:'+heightHeader+'px'">
          <table class="table table-bordered table-striped table-sm mb-0" style="width: 100%">
            <thead v-if="typeTable == 1">
              <tr>
                <th v-if="isCheckBox" class="text-center checkbox-width">
                  <input v-if="!isFixedColums" type="checkbox" id="selectAll" ref="selectAll" v-on:click="selectAll($event.currentTarget.checked)">
                  <input v-else type="checkbox">
                </th>
                <th v-if="isIndex" class="text-center index-width">{{$t('dataTable.labels.no')}}</th>
                <th scope="col"
                  v-for="column in columns" 
                  :key="column.field"
                  :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                  v-on:click="sort(column.field, column.sort, column.type)"
                  :style="{width:(column.width ? column.width : minWidth)+'px',
                      maxWidth:(column.width ? column.width : minWidth)+'px'}"
                >
                  <span v-html="column.label"/>
                  <i :class="(sorting && column.sort=='asc') ? 'fa fa-sort-up float-right mt-1' :
                  ((sorting && column.sort=='desc') ? 'fa fa-sort-down float-right mt-1':
                  (sorting && column.sort=='asc&desc') ? 'fa fa-sort float-right mt-1' : '')"></i>
                </th>
                <th v-if="isSort" class="text-center">{{$t('dataTable.labels.sort')}}
                </th>
                <th v-if="isCC060DispMode == 1" colspan="30" class="text-center">{{$t('common.labels.itemNm')}}
                </th>
              </tr>
            </thead>
            <thead v-if="typeTable == 4">
              <tr>
                <th :rowspan="rowspan" v-if="isCheckBox" class="text-center checkbox-width">
                  <input v-if="!isFixedColums" type="checkbox" id="selectAll" ref="selectAll" v-on:click="selectAll($event.currentTarget.checked)">
                  <input v-else type="checkbox">
                </th>
                <th :rowspan="rowspan" v-if="isIndex" class="text-center index-width">{{$t('dataTable.labels.no')}}</th>
                <template v-for="column in columns">
                  <th v-if="column.colspan == undefined && column.childCol == undefined" :rowspan="rowspan" scope="col"
                  :key="column.field"
                  :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                  v-on:click="sort(column.field, column.sort, column.type)"
                  :style="{width:(column.width ? column.width : minWidth)+'px',
                      maxWidth:(column.width ? column.width : minWidth)+'px'}"
                  >
                    <span v-html="column.label"/>
                    <i :class="(sorting && column.sort=='asc') ? 'fa fa-sort-up float-right mt-1' :
                    ((sorting && column.sort=='desc') ? 'fa fa-sort-down float-right mt-1':
                    (sorting && column.sort=='asc&desc') ? 'fa fa-sort float-right mt-1' : '')"></i>
                  </th>
                  <th v-else-if="column.colspan != undefined" :colspan="column.colspan" scope="col"
                  :key="column.field"
                  :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                  v-on:click="sort(column.field, column.sort, column.type)"
                  :style="{width:(column.width ? column.width : minWidth)+'px',
                      maxWidth:(column.width ? column.width : minWidth)+'px'}"
                  >
                    <span v-html="column.label"/>
                  </th>
                </template>
                
                <th :rowspan="rowspan" v-if="isSort" class="text-center">{{$t('dataTable.labels.sort')}}</th>
                <th :rowspan="rowspan" v-if="isCC060DispMode == 1" colspan="30" class="text-center">{{$t('common.labels.itemNm')}}</th>
              </tr>
              <!-- cc063 -->
              <tr>
                <template v-for="column in columns">
                  <th v-if="column.childCol == true" :rowspan="rowspan" scope="col"
                  :key="column.field"
                  :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                  v-on:click="sort(column.field, column.sort, column.type)"
                  :style="{width:(column.width ? column.width : minWidth)+'px',
                      maxWidth:(column.width ? column.width : minWidth)+'px'}"
                  >
                    <span v-html="column.label"/>
                    <i :class="(sorting && column.sort=='asc') ? 'fa fa-sort-up float-right mt-1' :
                    ((sorting && column.sort=='desc') ? 'fa fa-sort-down float-right mt-1':
                    (sorting && column.sort=='asc&desc') ? 'fa fa-sort float-right mt-1' : '')"></i>
                  </th>
                </template>
              </tr>
              <!-- cc063 -->
            </thead>
            <tbody class="tbody-hidden">
              <tr v-if="typeTable == 3" class="pading">
                <td v-for="(key, index) in columns.length" :key="key" >
                  <a v-if="index == 0" class="href-style" v-on:click="selectLink(pages[0][0], columns[index].field, true, false)">{{rowDefault}}</a>
                </td>
              </tr>
              <tr v-for="(row, rIndex) in pages[0]" :key="rIndex" class="pading">
                <td v-if="isCheckBox && typeTable != 3" class="text-center checkbox-width"><input type="checkbox" style="visibility:hidden"></td>
                <td v-if="isIndex && typeTable != 3" class="text-center index-width">{{(fromRecord-1)+rIndex+1}}</td>
                <template v-for="cIndex in (columns.length)">
                  <td v-if="columns[cIndex-1].colspan == undefined" :key="cIndex" :class="columns[cIndex - 1].style ? columns[cIndex - 1].style : ''"
                    :style="{width:(columns[cIndex-1].width ? columns[cIndex-1].width : minWidth)+'px',
                          maxWidth:(columns[cIndex-1].width ? columns[cIndex-1].width : minWidth)+'px'}">
                    <a v-if="columns[cIndex - 1].link" class="href-style" v-on:click="selectLink(row, columns[cIndex - 1].field, false)">{{row[columns[cIndex - 1].field]}}</a>
                    <template v-else-if="columns[cIndex - 1].formatNum">
                      <input-number v-if="row[columns[cIndex - 1].field] != undefined" v-model="row[columns[cIndex - 1].field]" :readonly="true"/>
                    </template>
                    <span v-else :style="'color :'+ (columns[cIndex - 1].color ? columns[cIndex - 1].color : '')">{{row[columns[cIndex - 1].field]}}</span>
                  </td>
                </template>
                <td v-if="isSort" class="text-center">
                  <div class="d-inline-flex">
                    <div class="col-md-6">
                      <i class="fa fa-chevron-circle-up pointer" :style="(fromRecord-1)+rIndex+1 != 1 ? '': 'visibility:hidden'" size="sm" @click="selectLink(pages[0][rIndex], 'isSortCol', false, true)"></i>
                    </div>
                    <div class="col-md-6">
                      <i class="fa fa-chevron-circle-down pointer" :style="(fromRecord-1)+rIndex+1 != totalRecord ? '': 'visibility:hidden'" size="sm" @click="selectLink(pages[0][rIndex], 'isSortCol', false, false)"></i>
                    </div>
                  </div>
                </td>
                <template v-if="isCC060DispMode == 1">
                  <td :style="{width:'100px',maxWidth:'100px'}"
                      v-for="i in 30" :key="rowsCC060[rIndex][i-1]">{{rowsCC060[rIndex][i-1]}}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="tableBody" ref="tableBody" class="dataTables-scrollBody table-responsive body-style" :style="(isWidthAuto ? 'width:auto;' : 'width:100%;')+'max-height:'+ maxHeight + 'px'" @scroll="tableScrollY">
          <table class="table table-bordered table-striped table-sm mb-0" style="width: 100%">
            <thead v-if="typeTable == 1" style="visibility:hidden;">
              <tr>
                <th v-if="isCheckBox" class="text-center checkbox-width"><input type="checkbox"></th>
                <th v-if="isIndex" class="text-center index-width">{{$t('dataTable.labels.no')}}</th>
                <th scope="col"
                  v-for="column in columns" 
                  :key="column.field"
                  :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                  v-on:click="sort(column.field, column.sort, column.type)"
                  :style="{width:(column.width ? column.width : minWidth)+'px',
                        maxWidth:(column.width ? column.width : minWidth)+'px'}">
                  <span v-html="column.label"/>
                  <i :class="(sorting && column.sort=='asc') ? 'fa fa-sort-up float-right mt-1' :
                  ((sorting && column.sort=='desc') ? 'fa fa-sort-down float-right mt-1':
                  (sorting && column.sort=='asc&desc') ? 'fa fa-sort float-right mt-1' : '')"></i>
                </th>
                <th v-if="isSort" class="text-center">{{$t('dataTable.labels.sort')}}</th>
                <th v-if="isCC060DispMode == 1" colspan="30" class="text-center">{{$t('common.labels.itemNm')}}</th>
              </tr>
            </thead>
            <thead v-if="typeTable == 4" style="visibility:hidden;">
              <tr>
                <th :rowspan="rowspan" v-if="isCheckBox" class="text-center checkbox-width">
                  <input v-if="!isFixedColums" type="checkbox" v-on:click="selectAll($event.currentTarget.checked)">
                  <input v-else type="checkbox">
                </th>
                <th :rowspan="rowspan" v-if="isIndex" class="text-center index-width">{{$t('dataTable.labels.no')}}</th>
                <template v-for="column in columns">
                  <th v-if="column.colspan == undefined && column.childCol == undefined" :rowspan="rowspan" scope="col"
                  :key="column.field"
                  :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                  v-on:click="sort(column.field, column.sort, column.type)"
                  :style="{width:(column.width ? column.width : minWidth)+'px',
                      maxWidth:(column.width ? column.width : minWidth)+'px'}"
                  >
                    <span v-html="column.label"/>
                    <i :class="(sorting && column.sort=='asc') ? 'fa fa-sort-up float-right mt-1' :
                    ((sorting && column.sort=='desc') ? 'fa fa-sort-down float-right mt-1':
                    (sorting && column.sort=='asc&desc') ? 'fa fa-sort float-right mt-1' : '')"></i>
                  </th>
                  <th v-else-if="column.colspan != undefined" :colspan="column.colspan" scope="col"
                  :key="column.field"
                  :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                  v-on:click="sort(column.field, column.sort, column.type)"
                  :style="{width:(column.width ? column.width : minWidth)+'px',
                      maxWidth:(column.width ? column.width : minWidth)+'px'}"
                  >
                    <span v-html="column.label"/>
                  </th>
                </template>
                
                <th :rowspan="rowspan" v-if="isSort" class="text-center">{{$t('dataTable.labels.sort')}}</th>
                <th :rowspan="rowspan" v-if="isCC060DispMode == 1" colspan="30" class="text-center">{{$t('common.labels.itemNm')}}</th>
              </tr>
              <!-- cc063 -->
              <tr>
                <template v-for="column in columns">
                  <th v-if="column.childCol == true" :rowspan="rowspan" scope="col"
                  :key="column.field"
                  :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                  v-on:click="sort(column.field, column.sort, column.type)"
                  :style="{width:(column.width ? column.width : minWidth)+'px',
                      maxWidth:(column.width ? column.width : minWidth)+'px'}"
                  >
                    <span v-html="column.label"/>
                    <i :class="(sorting && column.sort=='asc') ? 'fa fa-sort-up float-right mt-1' :
                    ((sorting && column.sort=='desc') ? 'fa fa-sort-down float-right mt-1':
                    (sorting && column.sort=='asc&desc') ? 'fa fa-sort float-right mt-1' : '')"></i>
                  </th>
                </template>
              </tr>
              <!-- cc063 -->
            </thead>
            <tbody>
              <slot name="fristRow" v-show="!isDisplay"></slot>
              <tr v-if="typeTable == 3" class="pading">
                <td v-for="(key, index) in columns.length" :key="key" >
                  <a v-if="index == 0" class="href-style" v-on:click="selectLink(pages[0][0], columns[index].field, true, false)">{{rowDefault}}</a>
                </td>
              </tr>
              <tr v-for="(row, rIndex) in pages[0]" :key="rIndex" class="pading" :class="'tr_'+rIndex"
                :style="row.STATUS!=null?('background:' + (row.STATUS == '-1'? '#ffcccc': row.STATUS == '1'?'#ffffcc': 'white' )):''">
                <td v-if="isCheckBox && typeTable != 3" class="text-center checkbox-width">
                  <template v-if="isFixedColums">
                    <input type="checkbox" style="visibility:hidden;">
                  </template>
                  <template v-else>
                    <input v-if="row.TABLE_CHECKBOX_D==true || row.TABLE_CHECKBOX_D == undefined" type="checkbox" name="checkBoxTable" @click="select(rIndex, $event.currentTarget.checked)" :data-item-no="row.ZAIKO_ITEM_NO_D">
                    <input v-else type="checkbox" style="visibility:hidden;">
                  </template>
                </td>
                <td v-if="isIndex && typeTable != 3" class="text-center index-width">{{(fromRecord-1)+rIndex+1}}</td>
                <template v-for="cIndex in (columns.length)">
                  <td v-if="columns[cIndex-1].colspan == undefined" :key="cIndex" :class="columns[cIndex - 1].style ? columns[cIndex - 1].style : ''" 
                    :style="{width:(columns[cIndex-1].width ? columns[cIndex-1].width : minWidth)+'px',
                          maxWidth:(columns[cIndex-1].width ? columns[cIndex-1].width : minWidth)+'px',
                          backgroundColor: (row[columns[cIndex - 1].field +'_COLOR'] == true && columns[cIndex-1].bgcolor ? columns[cIndex-1].bgcolor : '')}"
                    :title="row[columns[cIndex-1].field]">
                    <template v-if="columns[cIndex - 1].link">
                      <a v-if="row[columns[cIndex - 1].field+'_LINK'] == true || row[columns[cIndex - 1].field+'_LINK'] == undefined" class="href-style" v-on:click="selectLink(row, columns[cIndex - 1].field, false)">{{row[columns[cIndex - 1].field]}}</a>
                      <span v-else>{{row[columns[cIndex - 1].field]}}</span>
                    </template>
                    <template v-else-if="columns[cIndex - 1].formatNum">
                      <input-number v-if="row[columns[cIndex - 1].field] != undefined" v-model="row[columns[cIndex - 1].field]" :readonly="true"/>
                    </template>
                    <template v-else-if="columns[cIndex - 1].render">
                      <component :is="columns[cIndex - 1].render" :dataInfor="row" :extendData="extendData" :powerInfo="powerInfo" :rIndex="rIndex"></component>
                    </template>
                    <span v-else :style="'color :'+ (columns[cIndex - 1].color ? columns[cIndex - 1].color : '')">{{row[columns[cIndex - 1].field]}}</span>
                  </td>
                </template>
                <td v-if="isSort" class="text-center">
                  <div class="d-inline-flex">
                    <div class="col-md-6">
                      <i class="fa fa-chevron-circle-up pointer" :style="(fromRecord-1)+rIndex+1 != 1 ? '': 'visibility:hidden'" size="sm" @click="selectLink(pages[0][rIndex], 'isSortCol', false, true)"></i>
                    </div>
                    <div class="col-md-6">
                      <i class="fa fa-chevron-circle-down pointer" :style="(fromRecord-1)+rIndex+1 != totalRecord ? '': 'visibility:hidden'" size="sm" @click="selectLink(pages[0][rIndex], 'isSortCol', false, false)"></i>
                    </div>
                  </div>
                </td>
                <template v-if="isCC060DispMode == 1">
                  <td :title="rowsCC060[rIndex][i-1]" :style="{width:'100px',maxWidth:'100px'}" v-for="i in 30" :key="rowsCC060[rIndex][i-1]">{{rowsCC060[rIndex][i-1]}}</td>
                </template>
              </tr>
              <slot name="endRow" v-show="!isDisplay"></slot>
            </tbody>
          </table>
        </div>
        <!-- fix-header -->

        <!-- fix-column -->
        <div v-if="isFixedColums"  id="tableFixHeaderColumn" ref="tableFixHeaderColumn" class="table-responsive fix-header-style" :style="'max-height:'+heightHeader+'px'">
          <table class="table table-bordered table-striped table-sm mb-0">
            <thead v-if="typeTable == 1">
              <tr>
                <th v-if="isCheckBox" class="text-center checkbox-width">
                  <input v-if="isFixedColums" type="checkbox" id="selectAll" ref="selectAll" v-on:click="selectAll($event.currentTarget.checked)">
                  <input v-else type="checkbox">
                </th>
                <th v-if="isIndex" class="text-center index-width">{{$t('dataTable.labels.no')}}</th>
                <template v-for="column in columns">
                  <th scope="col" :key="column.field" 
                    :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                    v-on:click="sort(column.field, column.sort, column.type)"
                    :style="{width:(column.width ? column.width : minWidth)+'px',
                          maxWidth:(column.width ? column.width : minWidth)+'px'}"
                    v-if="column.fixed != undefined">
                    <span v-html="column.label"/>
                    <i :class="(sorting && column.sort=='asc') ? 'fa fa-sort-up float-right mt-1' :
                    ((sorting && column.sort=='desc') ? 'fa fa-sort-down float-right mt-1':
                    (sorting && column.sort=='asc&desc') ? 'fa fa-sort float-right mt-1' : '')"></i>
                  </th>
                </template>
                <th v-if="isSort" class="text-center">{{$t('dataTable.labels.sort')}}
                </th>
              </tr>
            </thead>
            <tbody class="tbody-hidden">
              <tr v-if="typeTable == 3" class="pading">
                <td v-for="(key, index) in columns.length" :key="key" >
                  <a v-if="index == 0" class="href-style" v-on:click="selectLink(pages[0][0], columns[index].field, true, false)">{{rowDefault}}</a>
                </td>
              </tr>
              <tr v-for="(row, rIndex) in pages[0]" :key="rIndex" class="pading">
                <td v-if="isCheckBox && typeTable != 3" class="text-center checkbox-width"><input type="checkbox"></td>
                <td v-if="isIndex && typeTable != 3" class="text-center index-width">{{(fromRecord-1)+rIndex+1}}</td>
                <template v-for="cIndex in (columns.length)">
                  <td :key="cIndex" :class="columns[cIndex - 1].style ? columns[cIndex - 1].style : ''" 
                  :style="{width: (columns[cIndex-1].width ? columns[cIndex-1].width : minWidth)+'px',
                        maxWidth: (columns[cIndex-1].width ? columns[cIndex-1].width : minWidth)+'px'}"
                  v-if="columns[cIndex - 1].fixed != undefined">
                    <a v-if="columns[cIndex - 1].link" class="href-style" v-on:click="selectLink(row, columns[cIndex - 1].field, false)">{{row[columns[cIndex - 1].field]}}</a>
                     <template v-else-if="columns[cIndex - 1].formatNum">
                     <input-number v-if="row[columns[cIndex - 1].field] != undefined" v-model="row[columns[cIndex - 1].field]" :readonly="true"/>
                    </template>
                    <span v-else :style="'color :'+ (columns[cIndex - 1].color ? columns[cIndex - 1].color : '')">{{row[columns[cIndex - 1].field]}}</span>
                  </td>
                </template>
                <td v-if="isSort" class="text-center">
                  <div class="d-inline-flex">
                    <div class="col-md-6">
                      <i class="fa fa-chevron-circle-up pointer" :style="(fromRecord-1)+rIndex+1 != 1 ? '': 'visibility:hidden'" size="sm" @click="selectLink(pages[0][rIndex], 'isSortCol', false, true)"></i>
                    </div>
                    <div class="col-md-6">
                      <i class="fa fa-chevron-circle-down pointer" :style="(fromRecord-1)+rIndex+1 != totalRecord ? '': 'visibility:hidden'" size="sm" @click="selectLink(pages[0][rIndex], 'isSortCol', false, false)"></i>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="isFixedColums"  id="tableFixBodyColumn" ref="tableFixBodyColumn" class="table-responsive fix-body-style" :style="'max-height:'+ (hasScrollLeftBar ? maxHeight-17 : maxHeight) + 'px'">
          <table class="table table-bordered table-striped table-sm mb-0">
            <thead v-if="typeTable == 1" style="visibility:hidden;">
              <tr>
                <th v-if="isCheckBox" class="text-center checkbox-width"><input type="checkbox"></th>
                <th v-if="isIndex" class="text-center index-width">{{$t('dataTable.labels.no')}}</th>
                <template v-for="column in columns">
                  <th scope="col"
                    :key="column.field"
                    :class="column.sort ? 'th-sm sorting text-center pointer' : 'th-sm sorting text-center'"
                    v-on:click="sort(column.field, column.sort, column.type)"
                    :style="{width:(column.width ? column.width : minWidth)+'px',
                          maxWidth:(column.width ? column.width : minWidth)+'px'}"
                    v-if="column.fixed != undefined"
                  >
                    <span v-html="column.label"/>
                    <i :class="(sorting && column.sort=='asc') ? 'fa fa-sort-up float-right mt-1' :
                    ((sorting && column.sort=='desc') ? 'fa fa-sort-down float-right mt-1':
                    (sorting && column.sort=='asc&desc') ? 'fa fa-sort float-right mt-1' : '')"></i>
                </th>
                </template>
                <th v-if="isSort" class="text-center">{{$t('dataTable.labels.sort')}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="typeTable == 3" class="pading">
                <td v-for="(key, index) in columns.length" :key="key" >
                  <a v-if="index == 0" class="href-style" v-on:click="selectLink(pages[0][0], columns[index].field, true, false)">{{rowDefault}}</a>
                </td>
              </tr>
              <tr v-for="(row, rIndex) in pages[0]" :key="rIndex" class="pading" :class="'tr_'+rIndex">
                <td v-if="isCheckBox && typeTable != 3" class="text-center checkbox-width">
                  <template v-if="isFixedColums">
                    <input v-if="row.TABLE_CHECKBOX_D==true || row.TABLE_CHECKBOX_D == undefined" type="checkbox" name="checkBoxTable" @click="select(rIndex, $event.currentTarget.checked)">
                    <input v-else type="checkbox" style="visibility:hidden;">
                  </template>
                </td>
                <td v-if="isIndex && typeTable != 3" class="text-center index-width">{{(fromRecord-1)+rIndex+1}}</td>
                <template v-for="cIndex in (columns.length)">
                  <td :key="cIndex" :class="columns[cIndex - 1].style ? columns[cIndex - 1].style : ''" 
                    :style="{width:(columns[cIndex-1].width ? columns[cIndex-1].width:minWidth)+'px',
                          maxWidth:(columns[cIndex-1].width ? columns[cIndex-1].width:minWidth)+'px'}"
                    :title="row[columns[cIndex-1].field]"
                    v-if="columns[cIndex - 1].fixed != undefined">
                      <a v-if="columns[cIndex - 1].link" class="href-style" v-on:click="selectLink(row, columns[cIndex - 1].field, false)">{{row[columns[cIndex - 1].field]}}</a>
                    <template v-else-if="columns[cIndex - 1].formatNum">
                     <input-number v-if="row[columns[cIndex - 1].field] != undefined" v-model="row[columns[cIndex - 1].field]" :readonly="true"/>
                    </template>
                      <span v-else :style="'color :'+ (columns[cIndex - 1].color ? columns[cIndex - 1].color : '')">{{row[columns[cIndex - 1].field]}}</span>
                  </td>
                </template>
                <td v-if="isSort" class="text-center">
                  <div class="d-inline-flex">
                    <div class="col-md-6">
                      <i class="fa fa-chevron-circle-up pointer" :style="(fromRecord-1)+rIndex+1 != 1 ? '': 'visibility:hidden'" size="sm" @click="selectLink(pages[0][rIndex], 'isSortCol', false, true)"></i>
                    </div>
                    <div class="col-md-6">
                      <i class="fa fa-chevron-circle-down pointer" :style="(fromRecord-1)+rIndex+1 != totalRecord ? '': 'visibility:hidden'" size="sm" @click="selectLink(pages[0][rIndex], 'isSortCol', false, false)"></i>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- fix-column -->
      </div>
      <!-- Main table -->

    </div>
    <!-- 検索条件に一致するデータがありませんでした。 -->
    <div v-if="isDisplay && !isError">
      <span v-if="isCC060DispMode == 1" :colspan="columns.length+30">{{$t('MSG.LOGIN.015[0]')}}{{$t('cc060KounyuHistory.labels.titleHeader')}}{{$t('MSG.LOGIN.015[1]')}}</span>
      <span v-else :colspan="columns.length"><b>{{$t('MSG.HA.001')}}</b></span>
    </div>
  </div>
</template>

<script>
import axios from "assets/js/request";
import $ from 'jquery';
import EventBus from 'assets/js/eventBus';
import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
import common from 'assets/js/common';
import InputNumber from 'components/InputNumber';
import InputCheck from 'components/InputCheck';

const Datatable = {
  /* 
  * Name of component
  */
  name: 'Datatable',
  /* 
  * Declare components
  */
  components: {
    bPagination,
    InputNumber,
    InputCheck
  },
  /* 
  * Get data from parent component
  */
  props: {
    data: {
      type: String,
      required: true
    },
    typeTable: {
      type: Number,
      default: 1
    },
    headerLabel: {
      type: String,
      default: ''
    },
    rowDefault: {
      type: String,
      default: ''
    },
    requestSearch: {
      type: Object
    },
    columnsTable: {
      type: Array
    },
    isIndex: {
      type: Boolean,
      default: true
    },
    isCheckBox: {
      type: Boolean,
      default: false
    },
    isSort: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number
    },
    maxHeight: {
      type: Number,
      default: 530
    },
    powerInfo: {
      type: Object
    },
    searching: {
      type: Boolean,
      default: true
    },
    isFixedColums: {
      type: Boolean,
      default: false
    },
    heightHeader: {
      type: Number,
      default: 28
    },
    rowspan: {
      type: Number,
      default: 2
    },
    isWidthAuto: {
      type: Boolean,
      default: false
    },
    isCC060DispMode: {
      type: Number,
      default: 0
    },
    isOD050DispMode: {
      type: Number,
      default: 0
    },
    isSY110DispMode: {
      type: Number,
      default: 0
    },
    extendData: {
      type: Object
    },
    hasPaginate: {
      type: Boolean,
      default: true
    },
    pageID: {
      type: String,
      default: ""
    }
  },
  /* 
  * Declare variable and set default value
  */
  data() {
    return {
      totalRecord: 0,
      fromRecord: 0,
      toRecord: 0,
      rows: [],
      rowsCC060:[],
      columns: [],
      arrays: [],
      requestModel: this.requestSearch,
      options: [
        {value: 10,text: "10行"},
        {value: 15,text: "15行"},
        {value: 30,text: "30行"},
        {value: 45,text: "45行"},
        {value: 50,text: "50行"},
        {value: 100,text: "100行"},
        {value: 200,text: "200行"},
        {value: 500,text: "500行"}
      ],
      pageSize: 30,
      pageNo: 1,
      goto: null,
      pages: [],
      isError: false,
      isDisplay: false,
      sorting: true,
      hasScrollTopBar: false,
      hasScrollLeftBar: false,
      styleWidth: '',
      minWidth: 120,
      tableWidth: 0,
      cIndex: 1,
      wrapperStyle: {
        maxWidth: this.maxWidth ? this.maxWidth : '100%',
        maxHeight: this.maxHeight+'px',
        margin: '0 auto',
        overflow: 'auto'
      }
    };
  },
  /* 
  * Computed
  */
  computed: {
    // filter objects by parameters match
    filteredRows() {
      var _this = this;
      if (_this.requestModel.quickSearch == undefined) {
        _this.requestModel.quickSearch = '';
      }
      return _this.rows.filter(row => {
        for (let key in row) {
          if (Object.prototype.hasOwnProperty.call(row, key)) {
            const stringValue = row[key].toString();
            if (stringValue.toLowerCase().match(_this.requestModel.quickSearch.toLowerCase())) return true;
          }
        }
        return false;
      }); 
    }
  },
  /* 
  * Methods
  */
  methods: {
    /* 
    * Method sorting
    */
    sort(field, sortType, type) {
      if (sortType == undefined) return;
      if (this.sorting) {
        sortType === 'asc' ?
          this.rows.sort(function(a, b) {
            var x = a[field];
            var y = b[field];
            if (type === 'num') {
              x = parseFloat(x.replace(",",""));
              y = parseFloat(y.replace(",",""));
            } else  if (type === 'date') {
              x = new Date(x);
              y = new Date(y);
              return x - y;
            }
            if (x === undefined) return 1
            else if (y === undefined) return -1
            return (x > y ? 1 : (x < y) ? -1 : 0)
          }) :
          this.rows.sort(function(a, b) {
            var x = a[field];
            var y = b[field];
            if (type === 'num') {
              x = parseFloat(x.replace(",",""));
              y = parseFloat(y.replace(",",""));
            } else  if (type === 'date') {
              x = new Date(x);
              y = new Date(y);
              return y - x;
            }
            if (x === undefined) return -1
            else if (y === undefined) return 1
            return (x > y ? -1 : (x < y) ? 1 : 0)
          });
        this.columns[this.columns.findIndex(column => column.field === field)].sort = sortType === 'asc' ? 'desc' : 'asc';
        for (var i in this.columns) {
          if (this.columns[i].field != field && this.columns[i].sort != undefined) {
            this.columns[i].sort = 'asc&desc';
          }
        }
      } 
    },
    firstPage() {
      this.pageNo = 1;
      this.changePage();
    },
    previousPage() {
      this.pageNo > 1 ? this.pageNo-- : this.pageNo = 1;
      this.changePage();
    },
    nextPage() {
      var totalPage = Math.ceil(this.totalRecord/this.pageSize);
      this.pageNo < totalPage ? this.pageNo++ : this.pageNo = totalPage;
      this.changePage();
    },
    lastPage() {
      var totalPage = Math.ceil(this.totalRecord/this.pageSize);
      this.pageNo = totalPage;
      this.changePage();
    },
    gotoPage() {
      if(this.goto == null || this.goto == "") return;
      var totalPage = Math.ceil(this.totalRecord/this.pageSize);
      this.goto > totalPage ? this.pageNo = totalPage : this.pageNo = this.goto;
      this.changePage();
    },
    /* 
    * Method change page number
    */
    changePage() {
      this.goto = null;
      if(this.$refs.tableBody != undefined) {
        this.$refs.tableBody.scrollTop = 0;
        this.$refs.tableBody.scrollLeft = 0
      }
      EventBus.$emit('page-info', this.pageNo, this.pageSize);
      this.init();
    },
    /* 
    * Method change page size
    */
    updatePageSize() {
      this.pageNo = 1;
      EventBus.$emit('page-info', this.pageNo, this.pageSize);
      this.init();
    },
    /* 
    * Method quick search
    */
    updateSearch(value) {
      if(this.$refs.selectAll != undefined) {
        if(value == "") {
          this.$refs.selectAll.disabled = false;
          this.$refs.selectAll.hidden = false;
        } else {
          this.$refs.selectAll.disabled = true;
          this.$refs.selectAll.hidden = true;
        }
      }
      value == "" ? this.sorting = true : this.sorting = false;
      var filter, tableList = [], tr, td, tdList, check = false;
      filter = value.toUpperCase();
      var table1 = this.$refs.tableBody;
      if(table1 != undefined) {
        tableList.push(table1);
      }
      
      for (var m = 0; m < tableList.length; m++) {
        tr = tableList[m].querySelector("tbody").querySelectorAll("tr");

        // Loop through all table rows, and hide those who don't match the search query
        for (var i = 0; i < tr.length; i++) {
          tdList = tr[i].getElementsByTagName("td");
          for (var j = 0; j < tdList.length; j++) {
            td = tdList[j];
            if (td) {
              if (td.textContent.toUpperCase().indexOf(filter) > -1) {
                if(!this.isCheckBox || j != 0) {
                  check = true;
                }
              }
            }
          }
          if (check) {
            tr[i].style.display = "";
            if(this.$refs.tableFixBodyColumn != undefined){
              let className = "."+tr[i].className.split(" ")[1];
              let fixTr = this.$refs.tableFixBodyColumn.querySelector(className);
              fixTr.style.display = "";
            }
            
          } else {
            tr[i].style.display = "none";
            if(this.$refs.tableFixBodyColumn != undefined){
              let className = "."+tr[i].className.split(" ")[1];
              let fixTr = this.$refs.tableFixBodyColumn.querySelector(className);
              fixTr.style.display = "none";
            }
          }
          check = false;
        }
      }
      if(this.$refs.tableBody == undefined) return;

      if (this.$refs.tableBody.scrollHeight - this.$refs.tableBody.clientHeight >= 17) {
        this.hasScrollTopBar = true;
      } else {
        this.hasScrollTopBar = false;
      }
      this.hasScrollTopBar ? this.styleWidth = 'width: calc(100% - 17px);' : this.styleWidth = 'width: 100%;';
      if (this.$refs.tableBody.offsetWidth - this.$refs.tableBody.clientWidth >= 17) {
        this.hasScrollLeftBar = true;
      } else {
        this.hasScrollLeftBar = false;
      }
    },
    /* 
    * Method init to call API to get data into list
    */
    init(){
      this.resetCheckbox();
      var _this = this;
      if (_this.requestModel.isPaging) {
        _this.pageSize = _this.requestModel.pageSize;
        _this.pageNo = _this.requestModel.pageNo;
        _this.requestModel.isPaging = false;
      } else {
        _this.requestModel.pageSize = _this.pageSize;
        _this.requestModel.pageNo = _this.pageNo;
      }
      _this.requestModel.quickSearch = '';
      _this.updateSearch('');
      EventBus.$emit('reset-page');
      // bind data or download form API
      EventBus.$emit('is-loading', true);
      axios.post(_this.data, _this.requestModel)
        .then(res => {
          _this.columns = $.extend([], _this.columnsTable);
          _this.rows = res.data.list;
          _this.totalRecord = res.data.totalRecord;
          _this.fromRecord = res.data.fromRecord;
          _this.toRecord = res.data.toRecord;
          _this.isDisplay = (res.data.list.length == 0) ? true : false;
          _this.isError = false;
          //special case CC060
          if(_this.isCC060DispMode == 1) {
            _this.rowsCC060 = res.data.itemDtl;
          }
          //special case OD050
          if(_this.isOD050DispMode == 1) {
            EventBus.$emit('OD050-koumokuList', res.data.koumokuList);
          }
          //special case SY110
          if(_this.isSY110DispMode == 1) {
            EventBus.$emit('SY110-koumokuList', res.data.koumokuList);
          }

          EventBus.$emit('list-dataSearch', _this.rows);
          let fromURL = this.data.split("/")[2];
          if(fromURL.substr(0,2) == 'cc') {
            EventBus.$emit('cc-data-resp', res.data);
          } else {
            EventBus.$emit('data-resp', res.data);
          }
          EventBus.$emit('is-loading', false);
        }).catch(err => {
          _this.resetCheckbox();
          _this.isError = true;
          EventBus.$emit('is-loading', false);
          common.errorAPI(err);
          common.scrollTop();
        });
    },

    /* 
    * Select a checkbox
    */
    select(rIndex, check) {
      var checkBoxes = $("input[name='checkBoxTable']");
      var _this = this;
      if(check) {
        _this.arrays.push(_this.rows[rIndex]);
        $('.tr_'+rIndex).addClass('selected');
      } else {
        _this.arrays = $.grep(_this.arrays, function(row){
                return row != _this.rows[rIndex];
            })
        $('.tr_'+rIndex).removeClass('selected');
      }

      if (_this.arrays.length == checkBoxes.length) {
        $('#selectAll').prop('checked', true);
      } else {
        $('#selectAll').prop('checked', false);
      }
      
      EventBus.$emit('selected', _this.arrays);
    },
    /* 
    * Select all checkboxes
    */
    selectAll(event) {
      var _this = this;
      var checkboxes = $("input[name=checkBoxTable]");
      var i, n;
      if(event) {
        _this.arrays = [];
        for(i=0, n=checkboxes.length;i<n;i++) {
          checkboxes[i].checked = true;
          _this.arrays.push(_this.rows[i]);
          let tr = checkboxes[i].parentElement.parentElement;
          if(!tr.classList.contains('selected')) {
            tr.className = tr.className + ' ' + 'selected';
          }
        }
        EventBus.$emit('selected', _this.arrays);
      } else {
        for(i=0, n=checkboxes.length;i<n;i++) {
          checkboxes[i].checked = false;
          checkboxes[i].parentElement.parentElement.className = checkboxes[i].parentElement.parentElement.className.replace(' selected','');
        }
        _this.arrays = [];
        EventBus.$emit('selected', []);
      }
    },
    /* 
    * Reset all checkboxes
    */
    resetCheckbox() {
      if (this.$refs.selectAll != undefined) {
        this.$refs.selectAll.checked = false;
      }
      this.selectAll(false);
    },
    /* 
    * Select a link will return data to parent component
    */
    selectLink: function(value, column, defaultSelect, isUp) {
      let selectValue = {};
      let fromURL = this.data.split("/")[2];
      selectValue.fromURL = fromURL;
      selectValue.value = value;
      selectValue.column = column;
      selectValue.defaultSelect = defaultSelect;
      selectValue.isUp = isUp;
      selectValue.requestModel = $.extend({}, this.requestModel);
      if(fromURL.substr(0,2) == 'cc') {
        EventBus.$emit('cc-select-link', selectValue);
      } else {
        EventBus.$emit('select-link', selectValue);
      }
    },
    /* 
    * fixed header when scrolling Y on table
    */
    tableScrollY: function() {
      let scrollLeft = this.$refs.tableBody.scrollLeft;
      this.$refs.tableHeader.scrollLeft = scrollLeft;

      if (this.isFixedColums) {
        let scrollTop = this.$refs.tableBody.scrollTop;
        this.$refs.tableFixBodyColumn.scrollTop = scrollTop;
      }
    }
  },
  /* 
  * Initialize
  */
  mounted: function() {
    var _this = this;
    _this.init();
    EventBus.$on('event-dataTable'+_this.pageID, function(requestModel, columnsTable, isCheckBox, url, from) {
      if (url == undefined){
        let fromURL = _this.data.split("/")[2];
        if(from!= undefined && fromURL.substr(0,2) != from) return;
      }
      
      // do something
      if(columnsTable != undefined) {
        _this.columns = $.extend([], columnsTable);
        _this.tableWidth = 0;
        for (var i = 0; i < columnsTable.length; i++) {
          if (columnsTable[i].colspan != undefined) continue;
          _this.tableWidth += columnsTable[i].width;
        }
        if(_this.isIndex) {
          _this.tableWidth += 50;
        }

        if(isCheckBox == undefined && _this.isCheckBox) {
          _this.tableWidth += 30;
        } 
        
        if(isCheckBox) {
          _this.tableWidth += 30;
        }
      }

      if (url != undefined){
        _this.data = url;
      }

      if(requestModel == undefined) {
        EventBus.$emit('reset-page');
        return;
      }

      _this.requestModel = $.extend({}, requestModel);
      if (_this.requestModel.isPaging) {
        _this.pageNo = _this.requestModel.pageNo;
        _this.pageSize = _this.requestModel.pageSize;
        _this.requestModel.isPaging = false;
        _this.changePage();
      } else {
        _this.pageNo = 1;
        _this.changePage();
      }
      
      EventBus.$emit('reset-page');
    });

    EventBus.$on('ms020_headerName', function (colorName, sizeName) {
      _this.columns[2].label = colorName;
      _this.columns[3].label = sizeName;
    });

    EventBus.$on('reset-checkBox', function () {
      _this.resetCheckbox();
    });
    this.tableWidth = 0;
    for (var i = 0; i < this.columnsTable.length; i++) {
      if (this.columnsTable[i].colspan != undefined) continue;
      this.tableWidth += this.columnsTable[i].width;
    }
    if(this.isIndex) {
      this.tableWidth += 50;
    }
    if(this.isCheckBox) {
      this.tableWidth += 30;
    }
    if(_this.isCC060DispMode == 1) {
      for (var j = 0; j < 30; j++) {
        this.tableWidth += 100;
      }
    }
  },
  /* 
  * Watch
  */
  watch: {
    pageSize() {
      EventBus.$emit('reset-page');
    },
    filteredRows() {
      // do the split on every change in rows (searching)
      this.pages = [];
      this.pages.push(this.rows);
    }
  },
  /* 
  * Updated to set width for header after render table
  */
  updated() {
    if(this.$refs.tableBody == undefined) return;

    if (this.$refs.tableBody.scrollHeight - this.$refs.tableBody.clientHeight >= 17) {
      this.hasScrollTopBar = true;
    } else {
      this.hasScrollTopBar = false;
    }
    this.hasScrollTopBar ? this.styleWidth = 'width: calc(100% - 17px);' : this.styleWidth = 'width: 100%;';
    if (this.$refs.tableBody.offsetWidth - this.$refs.tableBody.clientWidth >= 17) {
      this.hasScrollLeftBar = true;
    } else {
      this.hasScrollLeftBar = false;
    }
  },
  beforeDestroy: function () {
    EventBus.$off('event-dataTable'+this.pageID);
    EventBus.$off('ms020_headerName');
    EventBus.$off('reset-checkBox');
  }
};

export default Datatable;
</script>

<style scoped>
  .dataTables-scrollBody {
    display: block;
    overflow-y: auto;
    -ms-overflow-style: scrollbar;
  }

  .dataTables-scrollBody td,
  .dataTables-scrollBody th {
    white-space: nowrap;
  }

  .pointer {
    cursor: pointer;
  }

  .pading td {
    /* padding: 0 !important; */
    padding-top: 0.2rem !important;
    padding-bottom: 0.2rem !important;
  }

  .href-style {
    color: #1467f1 !important;
    cursor: pointer;
  }
  .select_pageSize {
    height: 30px !important;
  }
  .wrap-table {
    position: relative;
  }
  .thead-fixed {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  .tbody-hidden {
    visibility: hidden;
  }
  .tbody-hidden tr td {
    border: #fff transparent transparent;;
  }

  .header-style {
    z-index: 2;
    position: absolute;
    left: 0;
    top: -0.2px;
    overflow: hidden;
  }
  .body-style {
    z-index: 1;
    position:absolute;
  }
  .fix-header-style {
    z-index: 4;
    position: absolute;
    left: 0;
    top: -0.2px;
    overflow: hidden;
    width: auto;
  }
  .fix-body-style {
    z-index: 3;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    background: white;
    width: auto;
  }
  .checkbox-width {
    width: 30px;
  }
  .index-width {
    width: 50px;
  }
  .table-responsive {
    width: auto;
  }
  tbody .fa {
    font-size: 15px;
  }
  .custom-select-sm {
    font-size: 13px;
  }
  .seach-style {
    border:1px solid #AAAAAA;
    width:312px;
  }
  .seach-header-style {
    width:310px;
    background:#CCCCFF;
    font-size:13px
  }
  .table-sm td, .table-sm th {
    padding: 5px;
  }
  .table-sm td {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .selected {
    background-color: antiquewhite !important;
  }
  .table thead th {
    vertical-align: middle;
  }
  input[type='checkbox'] {
    margin-top: 2px;
    height: 13px !important;
  }
</style>